import MobXHttp from 'src/commons/store/MobXHttp'
import DealWithHttp from 'src/commons/store/DealWithHttp'
import BaseHttp from 'src/commons/store/BaseHttp'
import {
  HttpSuccessType1,
  API_URL,
  HttpSuccessType3,
  HttpSuccessType2,
  HttpSuccessType5,
} from 'src/commons/utils/Commons'

/*#region 提取第三方账号（新接口，可提取，可查询状态）*/
const userDrawAccount = BaseHttp<{ detailId: string }, ApiResult2<CheckGameOrderStatus>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/draw/account`,
})
export const DWuserDrawAccount = DealWithHttp(userDrawAccount, HttpSuccessType2)
export const userDrawAccountHS = MobXHttp(DWuserDrawAccount)

/*#region 用户参加的活动列表*/
const getUserReceivedActivities = BaseHttp<
  { token?: string },
  ApiResult2<{ activityNo: string; activityName: string }[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/received/activities`,
})
export const DWgetUserReceivedActivities = DealWithHttp(getUserReceivedActivities, HttpSuccessType2)
export const getUserReceivedActivitiesHS = MobXHttp(DWgetUserReceivedActivities)

/*#region 查询实名认证状态 0:未认证，1：已认证，2：审核中，3：审核拒绝*/
const getAuthStatusHttp = BaseHttp<{ token?: string }, ApiResult2<{ status: 0 | 1 | 2 | 3; message: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/realNameAuthStatus`,
})
export const DWGetAuthStatusHttp = DealWithHttp(getAuthStatusHttp, HttpSuccessType2)
export const GetAuthStatusHttpHS = MobXHttp(DWGetAuthStatusHttp)

/*#region 查询用户是否实名认证 */
const getIsRealNameAuthHttp = BaseHttp<{ token?: string }, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/isRealNameAuth`,
})
export const DWGetIsRealNameAuthHttp = DealWithHttp(getIsRealNameAuthHttp, HttpSuccessType2)
export const IsRealNameAuthHS = MobXHttp(DWGetIsRealNameAuthHttp)

/*#region 查询用户是否需要实名认证 */
const getIsNeedRealNameAuthHttp = BaseHttp<{ token?: string }, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/isNeedRealNameAuth`,
})
export const DWgetIsNeedRealNameAuthHttp = DealWithHttp(getIsNeedRealNameAuthHttp, HttpSuccessType2)
export const getIsNeedRealNameAuthHttpHS = MobXHttp(DWgetIsNeedRealNameAuthHttp)

/*获取国庆活动抽奖的次数*/
const getRemainLotteryNum = BaseHttp<
  { activityNo: string },
  ApiResult3<{ remainNum: number; lotteryType: 'expe' | 'forever'; activityNo: string }[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getRemainLotteryNumList`,
})
const DWGetRemainLotteryNum = DealWithHttp(getRemainLotteryNum, HttpSuccessType2)
export const getRemainLotteryNumHS = MobXHttp(DWGetRemainLotteryNum)

/*#region 获取实名认证信息 */
const getRealNameAuthHttp = BaseHttp<{ token?: string }, ApiResult2<AuthInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/userAuthInfo`,
})
export const DWGetRealNameAuthHttp = DealWithHttp(getRealNameAuthHttp, HttpSuccessType2)
export const RealNameAuthHS = MobXHttp(DWGetRealNameAuthHttp)

/*#region 实名认证接口 */
const bindRealNameAuthHttp = BaseHttp<{ realName: string; idCardNo: string }, ApiResult2<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/bind/realNameAuth`,
})
export const DWbindRealNameAuthHttp = DealWithHttp(bindRealNameAuthHttp, HttpSuccessType2)

/*#region 获取礼包的游戏列表 */
const getGiftGamesHttp = BaseHttp<{ orderNo: string }, ApiResult2<GiftGameList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/winPrizeBlessPackList`,
})

export const DWGetGiftGamesHttp = DealWithHttp(getGiftGamesHttp, HttpSuccessType2)

/*#region 微信登录检测*/
const CheckWeiXinLoginHttp = BaseHttp<CheckWeiXinLoginQuery, ApiResult<CheckWeiXinLogin>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/checkLogin`,
})

export const DWCheckWeiXinLoginHttp = DealWithHttp<
  CheckWeiXinLoginQuery,
  ApiResult<CheckWeiXinLogin>,
  CheckWeiXinLogin
>(CheckWeiXinLoginHttp, HttpSuccessType1)

export const CheckWeiXinLoginHS = MobXHttp<CheckWeiXinLoginQuery, CheckWeiXinLogin, null>(DWCheckWeiXinLoginHttp)
/*#endregion*/

/*#region 用户信息*/
// const UserInfoHttp = BaseHttp<LoginBaseQuery, ApiResult<UserInfo>>({ Type: 'Post', Url: `${API_URL.BOX_WEB}/api/me` })
const UserInfoHttp = BaseHttp<LoginBaseQuery, ApiResult<UserInfo>>({ Type: 'Post', Url: `${API_URL.BOX_WEB}/api/me` })

const DWUserInfoHttp = DealWithHttp<LoginBaseQuery, ApiResult<UserInfo>, UserInfo>(UserInfoHttp, HttpSuccessType1)

export const UserInfoHS = MobXHttp<LoginBaseQuery, UserInfo, null>(DWUserInfoHttp)
export const UserInfoHSTemp = MobXHttp<LoginBaseQuery, UserInfo, null>(DWUserInfoHttp)
/*#endregion*/

/*#region 发送手机验证码*/
const SendCodeHttp = BaseHttp<SendCodeQuery, ApiResult<SendCode>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/sendCode`,
})

export const DWSendCodeHttp = DealWithHttp<SendCodeQuery, ApiResult<SendCode>, SendCode>(SendCodeHttp, HttpSuccessType1)

const SendCodeHS = MobXHttp<SendCodeQuery, SendCode, null>(DWSendCodeHttp)
/*#endregion*/

/*#region 检测订单状态*/
const CheckGameOrderStatusHttp = BaseHttp<CheckGameOrderStatusQuery, ApiResult<CheckGameOrderStatus>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/checkOrder`,
})

export const DWCheckGameOrderStatusHttp = DealWithHttp<
  CheckGameOrderStatusQuery,
  ApiResult<CheckGameOrderStatus>,
  CheckGameOrderStatus
>(CheckGameOrderStatusHttp, HttpSuccessType1)

export const CheckGameOrderStatusHS = MobXHttp<CheckGameOrderStatusQuery, CheckGameOrderStatus, null>(
  DWCheckGameOrderStatusHttp,
)
/*#endregion*/

/*#region 用户登录*/
const UserLoginHttp = BaseHttp<UserLoginQuery, ApiResult<UserLogin>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/login`,
})

export const phpLoginHttp = DealWithHttp<UserLoginQuery, ApiResult<UserLogin>, UserLogin>(
  UserLoginHttp,
  HttpSuccessType1,
)

// const UserLoginHS = MobXHttp<UserLoginQuery, UserLogin, null>(phpLoginHttp)
/*#endregion*/

/*#region mac地址登录 */
const macLoginHttp = BaseHttp<UserMacLoginQuery, ApiResult3<UserLogin>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/deviceLogin`,
})

export const DWMacLoginHttp = DealWithHttp<UserMacLoginQuery, ApiResult3<UserLogin>, UserLogin>(
  macLoginHttp,
  HttpSuccessType2,
)
/*#endregion*/

/*#region 登录并记住密码*/
const RememberLoginHttp = BaseHttp<RememberLoginQuery, ApiResult<RememberLogin>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/remember`,
})

export const DWRememberLoginHttp = DealWithHttp<RememberLoginQuery, ApiResult<RememberLogin>, RememberLogin>(
  RememberLoginHttp,
  HttpSuccessType1,
)

const RememberLoginHS = MobXHttp<RememberLoginQuery, RememberLogin, null>(DWRememberLoginHttp)
/*#endregion*/

/*#region 记住用户登录*/
const LoginWithRememberHttp = BaseHttp<LoginWithRememberQuery, ApiResult<UserLogin>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/rememberLogin`,
})

export const DWLoginWithRememberHttp = DealWithHttp<LoginWithRememberQuery, ApiResult<UserLogin>, UserLogin>(
  LoginWithRememberHttp,
  HttpSuccessType1,
)
/*#endregion*/

/*#region 游戏订单列表*/
const GameOrdersHttp = BaseHttp<GameOrdersQuery, ApiResult<PageResult<GameOrder>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/orderList`,
})

const DWGameOrdersHttp = DealWithHttp<GameOrdersQuery, ApiResult<PageResult<GameOrder>>, PageResult<GameOrder>>(
  GameOrdersHttp,
  HttpSuccessType1,
)

export const GameOrdersHS = MobXHttp<GameOrdersQuery, PageResult<GameOrder>, null>(DWGameOrdersHttp)
/*#endregion*/

/*#region 游戏订单列表(新)*/
const UserOrdersHttp = BaseHttp<UserOrdersQuery, ApiResult3<PageResult2<GameOrder>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/order/query/page`,
})

export const DWUserOrdersHttp = DealWithHttp<
  UserOrdersQuery,
  ApiResult3<PageResult2<GameOrder>>,
  PageResult2<GameOrder>
>(UserOrdersHttp, HttpSuccessType2)
//商品订单
export const UserOrdersHS = MobXHttp<UserOrdersQuery, PageResult2<GameOrder>, null>(DWUserOrdersHttp)
//升级订单
export const UpgradeOrdersHS = MobXHttp<UserOrdersQuery, PageResult2<GameOrder>, null>(DWUserOrdersHttp)
//换购订单
export const ExchangeOrdersHS = MobXHttp<UserOrdersQuery, PageResult2<GameOrder>, null>(DWUserOrdersHttp)
/*#endregion*/

/*#region 充值订单列表*/
const UserRechargeOrdersHttp = BaseHttp<UserOrdersQuery, ApiResult3<PageResult2<GameOrder>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/order/query/recharge/page`,
})

const DWUserRechargeOrdersHttp = DealWithHttp<
  UserOrdersQuery,
  ApiResult3<PageResult2<GameOrder>>,
  PageResult2<GameOrder>
>(UserRechargeOrdersHttp, HttpSuccessType2)

export const UserRechargeOrdersHS = MobXHttp<UserOrdersQuery, PageResult2<GameOrder>, null>(DWUserRechargeOrdersHttp)
/*#endregion*/

/*#region CDK 兑换历史*/
const ExchangeLogsHttp = BaseHttp<ExchangeLogsQuery, ApiResult<PageResult<ExchangeLog>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/redeemList`,
})

const DWExchangeLogsHttp = DealWithHttp<ExchangeLogsQuery, ApiResult<PageResult<ExchangeLog>>, PageResult<ExchangeLog>>(
  ExchangeLogsHttp,
  HttpSuccessType1,
)

export const ExchangeLogsHS = MobXHttp<ExchangeLogsQuery, PageResult<ExchangeLog>, null>(DWExchangeLogsHttp)
/*#endregion*/

/*#region 兑换CDK*/
const ExchangeCDKHttp = BaseHttp<ExchangeCDKQuery, ApiResult<ExchangeResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/redeemCdk`,
})

export const DWExchangeCDKHttp = DealWithHttp<ExchangeCDKQuery, ApiResult<ExchangeResult>, ExchangeResult>(
  ExchangeCDKHttp,
  HttpSuccessType1,
)

const ExchangeCDKHS = MobXHttp<ExchangeCDKQuery, ExchangeResult, null>(DWExchangeCDKHttp)
/*#endregion*/

/*#region 创建订单*/
const CreateOrderHttp = BaseHttp<CreateOrderQuery, ApiResult<CreateOrder>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createGpOrder`,
})

export const DWCreateOrderHttp = DealWithHttp<CreateOrderQuery, ApiResult<CreateOrder>, CreateOrder>(
  CreateOrderHttp,
  HttpSuccessType1,
)

export const CreateOrderHS = MobXHttp<CreateOrderQuery, CreateOrder, null>(DWCreateOrderHttp)
/*#endregion*/

/*#region 创建订单 java*/
const CreateOrderJavaHttp = BaseHttp<CreateOrderBoxWebQuery, ApiResult2<CreateOrderBoxWeb>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/create`,
})

export const DWCreateOrderJavaHttp = DealWithHttp<
  CreateOrderBoxWebQuery,
  ApiResult2<CreateOrderBoxWeb>,
  CreateOrderBoxWeb
>(CreateOrderJavaHttp, HttpSuccessType2)

export const CreateOrderJavaHttpHS = MobXHttp<CreateOrderBoxWebQuery, CreateOrderBoxWeb, null>(DWCreateOrderJavaHttp)
/*#endregion*/

/*#region 创建订单 java*/
const getPreBalanceAmt = BaseHttp<CreateOrderBoxWebQuery, ApiResult2<GetPreBalanceAmtHS>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/pre/balance/amt`,
})

export const DWgetPreBalanceAmt = DealWithHttp<
  CreateOrderBoxWebQuery,
  ApiResult2<GetPreBalanceAmtHS>,
  GetPreBalanceAmtHS
>(getPreBalanceAmt, HttpSuccessType2)

export const getPreBalanceAmtHS = MobXHttp<CreateOrderBoxWebQuery, GetPreBalanceAmtHS, null>(DWgetPreBalanceAmt)
/*#endregion*/

/*#region 获取微信溢价比例 java*/
const getPreOverRate = BaseHttp<CreateOrderBoxWebQuery, ApiResult2<number>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/pre/over/rate`,
})

export const DWgetPreOverRate = DealWithHttp<CreateOrderBoxWebQuery, ApiResult2<number>, number>(
  getPreOverRate,
  HttpSuccessType2,
)

export const getPreOverRateHS = MobXHttp<CreateOrderBoxWebQuery, number, null>(DWgetPreOverRate)
/*#endregion*/

/*#region 获取微信溢价比例 java*/
const checkUserTag = BaseHttp<any, ApiResult2<TUserTag>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/query/user/tag`,
})

export const DWcheckUserTag = DealWithHttp<any, ApiResult2<TUserTag>, TUserTag>(checkUserTag, HttpSuccessType2)
/*#endregion*/

/*#region 查询vip订单是否成功 java*/
const VipCheckHttp = BaseHttp<{ orderNo: string }, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/box/vip/check`,
})

export const DWVipCheckHttp = DealWithHttp<{ orderNo: string }, ApiResult2<number>, number>(
  VipCheckHttp,
  HttpSuccessType2,
)
/*#endregion*/

/*#region 用户拓展信息  已废弃*/
// const UserExtendInfoHttp = BaseHttp<UserExtendInfo, ApiResult<UserInfoExtend>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX}/api/userInfo`,
// })
// const DWUserExtendInfoHttp = DealWithHttp<UserExtendInfo, ApiResult<UserInfoExtend>, UserInfoExtend>(
//   UserExtendInfoHttp,
//   HttpSuccessType1,
// )

// export const UserExtendInfoHS = MobXHttp<UserExtendInfo, UserInfoExtend, null>(DWUserExtendInfoHttp)
/*#endregion*/

/*#region java用户信息*/
const JAVAUserExtendInfoHttp = BaseHttp<UserExtendInfo, ApiResult<UserInfoExtend>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/isShowVipUpGrade`,
})
// const UserExtendInfoHttp = BaseHttp<UserExtendInfo, ApiResult<UserInfoExtend>>({ Type: 'Get', Url: `${API_URL.BOX_WEB}/api/userInfo` })

const DWJAVAUserExtendInfoHttpHttp = DealWithHttp<UserExtendInfo, ApiResult<UserInfoExtend>, UserInfoExtend>(
  JAVAUserExtendInfoHttp,
  HttpSuccessType1,
)

export const JAVAUserExtendInfoHS = MobXHttp<UserExtendInfo, UserInfoExtend, null>(DWJAVAUserExtendInfoHttpHttp)
/*#endregion*/

/*#region 用户登出*/
const UserLogoutHttp = BaseHttp<LoginBaseQuery, ApiResult<null>>({ Type: 'Post', Url: `${API_URL.BOX}/api/logout` })

export const DWUserLogoutHttp = DealWithHttp<LoginBaseQuery, ApiResult<null>, null>(UserLogoutHttp, HttpSuccessType1)

const UserLogoutHS = MobXHttp<LoginBaseQuery, null, null>(DWUserLogoutHttp)
/*#endregion*/

/*#region 开通 VIP 订单*/
const CreateVIPOrderHttp = BaseHttp<CreateVIPOrder, ApiResult<CreateVIPOrderResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createVipOrder`,
})

const DWCreateVIPOrderHttp = DealWithHttp(CreateVIPOrderHttp, HttpSuccessType1)

export const CreateVIPOrderHS = MobXHttp(DWCreateVIPOrderHttp)
/*#endregion*/

/*#region 获取财务订单详情*/
const FinanceDetailHttp = BaseHttp<CheckGameOrderStatusQuery, ApiResult<Order>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/financeDetail`,
})

export const DWFinanceDetailHttp = DealWithHttp(FinanceDetailHttp, HttpSuccessType1)
/*#endregion*/

/*#region 新人大礼包信息*/
const NewUserGiftHttp = BaseHttp<{ token?: string }, ApiResult<NewUserGiftInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getNewGiftInfo`,
})

const DWNewUserGiftHttp = DealWithHttp(NewUserGiftHttp, HttpSuccessType1)

export const NewUserGiftHS = MobXHttp(DWNewUserGiftHttp)
/*#endregion*/

/*#region 领取新人大礼包*/
const ReceiveNewUserGiftHttp = BaseHttp<ReceiveNewUserGiftQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/receiveNewGift`,
})

export const DWReceiveNewUserGiftHttp = DealWithHttp(ReceiveNewUserGiftHttp, HttpSuccessType1)
/*#endregion*/

/*#region 获取关注公众号二维码*/
const GetWeChatQRCodeHttp = BaseHttp<null, ApiResult<{ url: string; ticket: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getWechatCode`,
})

const DWGetWeChatQRCodeHttp = DealWithHttp(GetWeChatQRCodeHttp, HttpSuccessType1)

export const GetWeChatQRCodeHS = MobXHttp(DWGetWeChatQRCodeHttp)
/*#endregion*/

/*#region 查询关注公众号状态*/
const CheckWeChatAttentionHttp = BaseHttp<{ token?: string; ticket: string }, ApiResult<TCheckWeChatAttentionHttp>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/checkOfficeLogin`,
})

export const DWCheckWeChatAttentionHttp = DealWithHttp(CheckWeChatAttentionHttp, HttpSuccessType1)
/*#endregion*/

/*#region 获取用户资金明细*/
const FinanceListHttp = BaseHttp<FinanceListQuery, ApiResult<PageResult<FinanceList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/financeList`,
})
const DWFinanceListHttp = DealWithHttp(FinanceListHttp, HttpSuccessType1)

export const FinanceListHS = MobXHttp(DWFinanceListHttp)
/*#endregion*/

/*#region 账户充值*/
const UserRechargeHttp = BaseHttp<UserRechargeQuery, ApiResult<TUserRechargeHttp>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/recharge`,
})

export const DWUserRechargeHttp = DealWithHttp(UserRechargeHttp, HttpSuccessType1)
/*#endregion*/

/*#region 绑定手机号*/
const BindMobileHttp = BaseHttp<BindMobileQuery, ApiResult<{ token: string }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/bindMobile`,
})

export const DWBindMobileHttp = DealWithHttp(BindMobileHttp, HttpSuccessType3)

export const BindMobileHS = MobXHttp(DWBindMobileHttp)
/*#endregion*/

/*#region 微信登录的绑定手机号弹窗调用*/
const wechatLogin = BaseHttp<{ account: string; code: string; state: string }, ApiResult<{ token: string }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/anon/wechatLogin`,
})

export const DWwechatLogin = DealWithHttp(wechatLogin, HttpSuccessType3)

export const wechatLoginHS = MobXHttp(DWwechatLogin)
/*#endregion*/

/*#region 解绑微信*/
const unbindWechat = BaseHttp<{}, ApiResult2<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/user/unbind/wechat`,
})

export const DWunbindWechat = DealWithHttp(unbindWechat, HttpSuccessType2)
/*#endregion*/

/*#region 校验手机号是否已注册用户*/
const checkAccountIsRegister = BaseHttp<{ account: string }, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/api/checkAccountIsRegister`,
})

export const DWcheckAccountIsRegister = DealWithHttp(checkAccountIsRegister, HttpSuccessType2)

export const checkAccountIsRegisterHS = MobXHttp(DWcheckAccountIsRegister)
/*#endregion*/

/*#region 获取微信授权登录地址*/
const GetWeChatAuthCodeHttp = BaseHttp<null, ApiResult<{ url: string; ticket: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getAuthCode`,
})

const DWGetWeChatAuthCode = DealWithHttp(GetWeChatAuthCodeHttp, HttpSuccessType1)

export const GetWeChatAuthCodeHS = MobXHttp(DWGetWeChatAuthCode)

/*@endregion*/

/*#region 填写保证金提取支付宝账号*/
const DepositFillAccountHttp = BaseHttp<DepositFillAccountQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/fillAccount`,
})
export const DWDepositFillAccountHttp = DealWithHttp(DepositFillAccountHttp, HttpSuccessType1)
/*#endregion*/

/*#region 微信登录检测*/
const bindWechat = BaseHttp<CheckWeiXinLoginQuery, ApiResult3<CheckWeiXinLogin>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/user/bind/wechat`,
})

export const DWbindWechat = DealWithHttp(bindWechat, HttpSuccessType5)
/*#endregion*/

/*#region 检测订单状态*/
const CheckDepositeGameOrderStatusHttp = BaseHttp<CheckGameOrderStatusQuery1, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/deposite/order/check`,
})

export const DWCheckDepositeGameOrderStatusHttp = DealWithHttp<CheckGameOrderStatusQuery1, ApiResult2<number>, number>(
  CheckDepositeGameOrderStatusHttp,
  HttpSuccessType2,
)

export const CheckDepositeGameOrderStatusHS = MobXHttp<CheckGameOrderStatusQuery1, number, null>(
  DWCheckDepositeGameOrderStatusHttp,
)
/*#endregion*/

/*#region 检测充值订单状态*/
const checkRechargeOrderStatusHttp = BaseHttp<{ orderNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/recharge/order/check`,
})

export const DWcheckRechargeOrderStatusHttp = DealWithHttp<{ orderNo: string }, ApiResult3<number>, number>(
  checkRechargeOrderStatusHttp,
  HttpSuccessType2,
)

export const checkRechargeOrderStatusHS = MobXHttp<{ orderNo: string }, number, null>(DWcheckRechargeOrderStatusHttp)
/*#endregion*/

/*#region 检测订单状态*/
const CheckOrderStatusHttp = BaseHttp<CheckGameOrderStatusQuery1, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/check`,
})

export const DWCheckOrderStatusHttp = DealWithHttp<CheckGameOrderStatusQuery1, ApiResult2<number>, number>(
  CheckOrderStatusHttp,
  HttpSuccessType2,
)

export const CheckOrderStatusHttpHS = MobXHttp<CheckGameOrderStatusQuery1, number, null>(DWCheckOrderStatusHttp)
/*#endregion*/

/*#region 获取box_web的授权*/
// export const GetBoxWebPower = BaseHttp<{ token: string }, ApiResult2<any>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/sso/token`,
// })

// const DWGetBoxWebPower = DealWithHttp(GetBoxWebPower, HttpSuccessType2)

// export const GetBoxWebPowerHS = MobXHttp(DWGetBoxWebPower)

/*@endregion*/

/*#region 登出*/
export const BoxWebLogout = BaseHttp<null, ApiResult<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/sso/logout`,
})
/*@endregion*/

/*#region 购买第三方商品创建订单*/
const CreateThirdOrderHttp = BaseHttp<CreateThirdOrderQuery, ApiResult<CreateThirdOrder>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createThirdOrder`,
})
const DWCreateThirdOrderHttp = DealWithHttp(CreateThirdOrderHttp, HttpSuccessType1)
export const CreateThirdOrderHS = MobXHttp(DWCreateThirdOrderHttp)
/*#endregion*/

/*#region 用户加速器信息*/
const UserJsqInfoHttp = BaseHttp<{ token?: string }, ApiResult3<UserJsqInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/speed/info`,
})
export const DWUserJsqInfoHttp = DealWithHttp(UserJsqInfoHttp, HttpSuccessType2)

export const UserJsqInfoHS = MobXHttp(DWUserJsqInfoHttp)
/*#endregion*/

/*#region 用户默认区服*/
const UserJsqDefaultAreaHttp = BaseHttp<{ gameId: number; userId: number }, ApiResult3<JsqAreaInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/speedArea/getUserDefualt`,
})
const DWUserJsqDefaultAreaHttp = DealWithHttp(UserJsqDefaultAreaHttp, HttpSuccessType2)

export const UserJsqDefaultAreaHS = MobXHttp(DWUserJsqDefaultAreaHttp)
/*#endregion*/

/*#region 根据上号单号获取用户加速器信息*/
const GetUserJsqInfoByStartGameNo = BaseHttp<{ startGameNo: string }, ApiResult3<JsqRunningTime>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/speed/info/by/startGameNo`,
})
const DWGetUserJsqInfoByStartGameNoHttp = DealWithHttp(GetUserJsqInfoByStartGameNo, HttpSuccessType2)

export const GetUserJsqInfoByStartGameNoHS = MobXHttp(DWGetUserJsqInfoByStartGameNoHttp)
/*#endregion*/

/*#region 根据用户查询当前是否有排队中的游戏*/
const queryQueueInfoByUser = BaseHttp<{ startGameNo: string }, ApiResult3<JsqRunningTime>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/game/queue/query`,
})
const DWqueryQueueInfoByUserHttp = DealWithHttp(queryQueueInfoByUser, HttpSuccessType2)

export const queryQueueInfoByUserHS = MobXHttp(DWqueryQueueInfoByUserHttp)
/*#endregion*/

/*#region 加速器商品列表*/
const JsqProductHttp = BaseHttp<{ activityNo?: string }, ApiResult<ModDataItem<JsqProduct>[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getJsqProduct`,
})
const DWJsqProductHttp = DealWithHttp(JsqProductHttp, HttpSuccessType1)

export const JsqProductHS = MobXHttp(DWJsqProductHttp)
/*#endregion*/

/*#region 微信登录绑定手机号*/
const BindLoginMobileHttp = BaseHttp<BindLoginMobileQuery, ApiResult<BindLoginMobileResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/bindLoginMobile`,
})
const DWBindLoginMobileHttp = DealWithHttp(BindLoginMobileHttp, HttpSuccessType1)
export const BindLoginMobileHS = MobXHttp(DWBindLoginMobileHttp)
/*#endregion*/

/*#region 加速器商品列表*/
const UserGameDataHttp = BaseHttp<{ token?: string }, ApiResult<UserGameData>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getUserGameData`,
})
const DWUserGameDataHttp = DealWithHttp(UserGameDataHttp, HttpSuccessType1)

export const UserGameDataHS = MobXHttp(DWUserGameDataHttp)
/*#endregion*/

/*#region 通过购买订单号获取游戏库ID */
const getUserGameIdByOrderNoHttp = BaseHttp<{ orderNo: string }, ApiResult2<UserGameData>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getUserGame`,
})
const DWgetUserGameIdByOrderNoHttpHttp = DealWithHttp(getUserGameIdByOrderNoHttp, HttpSuccessType2)

export const getUserGameIdByOrderNoHttpHS = MobXHttp(DWgetUserGameIdByOrderNoHttpHttp)
/*#endregion*/

/*#region 用户平台游戏列表*/
const UserPlatGameListHttp = BaseHttp<{ token: string; platform: string }, ApiResult<UserPlatGameList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getUserPlatGameList`,
})
const DWUserPlatGameListHttp = DealWithHttp(UserPlatGameListHttp, HttpSuccessType1)

export const UserPlatGameListHS = MobXHttp(DWUserPlatGameListHttp)
/*#endregion*/

/*#region 获取用户平台游戏数据*/
const UserPlatGameHttp = BaseHttp<{ token?: string }, ApiResult<UserPlatGame[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getUserPlatGame`,
})
const DWUserPlatGameHttp = DealWithHttp(UserPlatGameHttp, HttpSuccessType1)

export const UserPlatGameHS = MobXHttp(DWUserPlatGameHttp)
/*#endregion*/

/*#region 设置支付密码*/
const SetPayPasswordHttp = BaseHttp<SetPayPasswordQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/setPayPassword`,
})
export const DWSetPayPasswordHttp = DealWithHttp(SetPayPasswordHttp, HttpSuccessType1)
/*#endregion*/

/*#region 绑定支付宝*/
const BindAliPayHttp = BaseHttp<BindAliPayQuery, ApiResult<{ token?: string }>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/bindAlipay`,
})
export const DWBindAliPayHttp = DealWithHttp(BindAliPayHttp, HttpSuccessType1)
/*#endregion*/

/*#region 申请提现*/
const ApplyWithdrawHttp = BaseHttp<ApplyWithdrawQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/withdrawApply`,
})
export const DWApplyWithdrawHttp = DealWithHttp(ApplyWithdrawHttp, HttpSuccessType1)
/*#endregion*/

/*#region 取消提现*/
const CancelWithdrawHttp = BaseHttp<{ orderNo: string }, ApiResult3<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/withdraw/cancel`,
})
export const DWCancelWithdrawHttp = DealWithHttp(CancelWithdrawHttp, HttpSuccessType2)
/*#endregion*/

/*#region 获取提现申请列表接口*/
const withdrawListHttp = BaseHttp<{ token: string } & PageQuery, ApiResult<PageResult<WithdrawList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/withdrawList`,
})
const DWwithdrawListHttp = DealWithHttp(withdrawListHttp, HttpSuccessType1)

export const withdrawListHS = MobXHttp(DWwithdrawListHttp)
/*#endregion*/

/*#region 获取押金列表*/
const depositTakeListHttp = BaseHttp<{ pageNo: number; pageSize: number }, ApiResult3<PageResult2<Deposit>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/depositTakeList`,
})
const DWDepositTakeListHttp = DealWithHttp(depositTakeListHttp, HttpSuccessType2)

export const depositTakeListHS = MobXHttp(DWDepositTakeListHttp)
/*#endregion*/

/*#region 修改昵称*/
const updateNicknameHttp = BaseHttp<{ token: string; nickname: string }, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/updateNickname`,
})
const DWupdateNicknameHttp = DealWithHttp(updateNicknameHttp, HttpSuccessType1)

export const updateNicknameHS = MobXHttp(DWupdateNicknameHttp)
/*#endregion*/

/*#region 同步修改昵称到论坛*/
const syncNicknameHttp = BaseHttp<{ nickname: string; userId?: number }, ApiResult3<null>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/user/modifiedUserName`,
})
const DWsyncNicknameHttp = DealWithHttp(syncNicknameHttp, HttpSuccessType2)

export const syncNicknameHS = MobXHttp(DWsyncNicknameHttp)
/*#endregion*/

/*#region 修改头像*/
const updateAvatarHttp = BaseHttp<{ token: string; avatar: string }, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/updateAvatar`,
})
const DWupdateAvatarHttp = DealWithHttp(updateAvatarHttp, HttpSuccessType1)

export const updateAvatarHS = MobXHttp(DWupdateAvatarHttp)
/*#endregion*/

/*#region 同步头像修改到论坛*/
const syncAvatarHttp = BaseHttp<{ avatar: string; userId?: number }, ApiResult3<null>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/user/modifiedUserAvatar`,
})
const DWsyncAvatarHttp = DealWithHttp(syncAvatarHttp, HttpSuccessType2)

export const syncAvatarHS = MobXHttp(DWsyncAvatarHttp)
/*#endregion*/

/*#region 获取vip客服服务订单*/
const getVipServiceOrderHttp = BaseHttp<{ gameId?: number }, ApiResult2<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/queryUserVipSercerOrder`,
})
const DWGetVipServiceOrderHttp = DealWithHttp(getVipServiceOrderHttp, HttpSuccessType2)

export const getVipServiceOrderHS = MobXHttp(DWGetVipServiceOrderHttp)
/*#endregion*/

/* VIP下单接口*/
const createMemberOrderHttp = BaseHttp<TCreateMemberOrderHttp, ApiResult<CreateVIPOrderResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/createMemberOrder`,
})
const DWcreateMemberOrderHttp = DealWithHttp(createMemberOrderHttp, HttpSuccessType1)

export const createMemberOrderHS = MobXHttp(DWcreateMemberOrderHttp)
/*#endregion*/

/*#region 升级cdk创建的订单*/
const createUpgradeOrderHttp = BaseHttp<CreateOrderBoxWebQuery, ApiResult2<CreateOrderBoxWeb>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/create`,
})
const DWCreateUpgradeOrderHttp = DealWithHttp(createUpgradeOrderHttp, HttpSuccessType2)
export const createUpgradeOrderHS = MobXHttp(DWCreateUpgradeOrderHttp)
/*#endregion*/

/*#region 预结算 */
const orderPreBalance = BaseHttp<CreateOrderBoxWebQuery, ApiResult2<CreateOrderBoxWeb>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/pre/balance/amt`,
})
const DWorderPreBalanceHttp = DealWithHttp(orderPreBalance, HttpSuccessType2)
export const orderPreBalanceHS = MobXHttp(DWorderPreBalanceHttp)
/*#endregion*/

/*#region 发起支付*/
const createPayHttp = BaseHttp<PayLaunchQuery, ApiResult2<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/pay/payLaunch`,
})
const DWCreatePayHttp = DealWithHttp(createPayHttp, HttpSuccessType2)
export const createPayHS = MobXHttp(DWCreatePayHttp)
/*#endregion*/

/*#region 查询老用户回归礼资格*/
const RecallHttp = BaseHttp<any, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/could/sign`,
})
const DWRecallHttp = DealWithHttp(RecallHttp, HttpSuccessType2)
export const RecallHS = MobXHttp(DWRecallHttp)
/*#endregion*/

/*#region 查询老用户回归领取天数*/
const RecallDayHttp = BaseHttp<
  any,
  ApiResult2<{
    signNum: number
    signedToday: boolean
  }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/last/sign`,
})
const DWRecallDayHttp = DealWithHttp(RecallDayHttp, HttpSuccessType2)
export const RecallDayHS = MobXHttp(DWRecallDayHttp)
/*#endregion*/

/*#region 领取老用户回归领取天数*/
const RecallReceiveHttp = BaseHttp<any, ApiResult2<RecallReceiveType>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/sign/rewards`,
})
const DWRecallReceiveHttp = DealWithHttp(RecallReceiveHttp, HttpSuccessType2)
export const RecallReceiveHS = MobXHttp(DWRecallReceiveHttp)
/*#endregion*/

/*#region 意见反馈列表*/
const getOpinionList = BaseHttp<{ token: string; page: number; pageSize: number }, ApiResult3<WithPages<OpinionData>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/feedbackList`,
})
const DWGetOpinionList = DealWithHttp(getOpinionList, HttpSuccessType2)
export const getOpinionListHS = MobXHttp(DWGetOpinionList)
/*#endregion*/

/*#region 修改意见反馈读取状态*/
const getOpinionStatus = BaseHttp<{ token: string; feedId: string | number }, ApiResult3<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/updateReadStatus`,
})
const DWGetOpinionStatus = DealWithHttp(getOpinionStatus, HttpSuccessType2)
export const getOpinionStatusHS = MobXHttp(DWGetOpinionStatus)
/*#endregion*/

/*#region 是否显示五一活动入口*/
const qualification = BaseHttp<
  { activityNo: string; channel?: string },
  ApiResult3<{ eligible: boolean; participated: boolean; refund: boolean }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/get/labor/day/lottery/activity/qualification`,
})
const DWqualification = DealWithHttp(qualification, HttpSuccessType2)
export const qualificationHS = MobXHttp(DWqualification)
/*#endregion*/

/*#region 获取奖品列表查询*/
const getPrizeList = BaseHttp<
  { activityNo: string; channel: string; lotteryType?: string },
  ApiResult3<prizeListType[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/prizeList`,
})
const DWGetPrizeList = DealWithHttp(getPrizeList, HttpSuccessType2)
export const getPrizeListHS = MobXHttp(DWGetPrizeList)
/*#endregion*/

/*#region 获取用户中奖记录列表*/
const getWinPrizeList = BaseHttp<{ activityNo: string }, ApiResult3<winPrizeListType[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/winPrizeList`,
})
const DWGetWinPrizeList = DealWithHttp(getWinPrizeList, HttpSuccessType2)
export const getWinPrizeListHS = MobXHttp(DWGetWinPrizeList)
/*#endregion*/

/*#region 用户抽奖接口*/
const lottery = BaseHttp<
  { activityNo: string; channel: string; lotteryType?: 'expe' | 'forever'; isNew?: boolean },
  ApiResult3<lotteryType[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/lottery`,
})
const DWLottery = DealWithHttp(lottery, HttpSuccessType2)
export const lotteryHS = MobXHttp(DWLottery)
/*#endregion*/

/*#region 用户选择试玩卡游戏列表*/
const gpGameList = BaseHttp<{ activityNo: string; ids: string }, ApiResult<{ data: GameDetail[] }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/gpGameList`,
})
export const DWGpGameList = DealWithHttp(gpGameList, HttpSuccessType1)
export const gpGameListHS = MobXHttp(DWGpGameList)
/*#endregion*/

/*#region 我的中奖纪录列表查询*/
const getMyWinPrizeList = BaseHttp<
  { activityNo: string; pageNo: number; pageSize: number },
  ApiResult3<WithPages<lotteryType>>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/myWinPrizeList`,
})
const DWGetMyWinPrizeList = DealWithHttp(getMyWinPrizeList, HttpSuccessType2)
export const getMyWinPrizeListHS = MobXHttp(DWGetMyWinPrizeList)
/*#endregion*/

/*#region 试玩卡选择游戏增加到游戏库接口*/
const trialCardAddUserGame = BaseHttp<{ activityNo: string; itemNo: string; gameId: number }, ApiResult3<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/trialCardAddUserGame`,
})
const DWTrialCardAddUserGame = DealWithHttp(trialCardAddUserGame, HttpSuccessType2)
export const trialCardAddUserGameHS = MobXHttp(DWTrialCardAddUserGame)
/*#endregion*/

/*#region 获取用户抽奖次数*/
const getLotteryNum = BaseHttp<{ activityNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/lotteryNum`,
})
const DWGetLotteryNum = DealWithHttp(getLotteryNum, HttpSuccessType2)
export const getLotteryNumHS = MobXHttp(DWGetLotteryNum)
/*#endregion*/

/*#region 获取端午节活动信息*/
const getActivityInfo = BaseHttp<{ activityNo: string }, ApiResult3<IActivityConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activityInfo`,
})
const DWGetActivityInfo = DealWithHttp(getActivityInfo, HttpSuccessType2)
export const getActivityInfoHS = MobXHttp(DWGetActivityInfo)
/*#endregion*/

/*#region 获取用户在论坛侧的信息*/
const getUserInfoForComment = BaseHttp<any, ApiResult3<TGetUserInfoForCommentResult>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/user/getBbsUserMsg`,
})
const DWgetUserInfoForComment = DealWithHttp(getUserInfoForComment, HttpSuccessType2)
export const getUserInfoForCommentHS = MobXHttp(DWgetUserInfoForComment)
/*#endregion*/

/*#region 获取用户在论坛侧的信息*/
const editUserNameForComment = BaseHttp<TEditUserNameForComment, ApiResult3<TGetUserInfoForCommentResult>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/user/modifiedUserName`,
})
const DWeditUserNameForComment = DealWithHttp(editUserNameForComment, HttpSuccessType2)
export const editUserNameForCommentHS = MobXHttp(DWeditUserNameForComment)
/*#endregion*/

/*#region 获取用户的折扣码*/
const getUserDiscountCode = BaseHttp<any, ApiResult3<TGetUserDiscountCode>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/userCode/myDiscountCode`,
})
const DWGetUserDiscountCode = DealWithHttp(getUserDiscountCode, HttpSuccessType2)
export const getUserDiscountCodeHS = MobXHttp(DWGetUserDiscountCode)
/*#endregion*/

/*#region 是否展示折扣码*/
const isShowDiscountCode = BaseHttp<any, ApiResult3<TGetUserInfoForCommentResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/userCode/isShowDiscountCode`,
})
const DWisShowDiscountCode = DealWithHttp(isShowDiscountCode, HttpSuccessType2)
export const isShowDiscountCodeHS = MobXHttp(DWisShowDiscountCode)
/*#endregion*/

/*#region 获取折扣码返利统计信息*/
const getDiscountCodePriceAmount = BaseHttp<any, ApiResult3<TGetDiscountCodePriceAmount>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/discount/code/rebate/info`,
})
const DWgetDiscountCodePriceAmount = DealWithHttp(getDiscountCodePriceAmount, HttpSuccessType2)
export const getDiscountCodePriceAmountHS = MobXHttp(DWgetDiscountCodePriceAmount)
/*#endregion*/

/*#region 获取返利信息列表数据*/
const getDiscountCodeRebateListHttp = BaseHttp<any, ApiResult3<WithPages<TGetDiscountCodePriceAmount>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/discount/code/rebate/list`,
})
const DWgetDiscountCodeRebateListHttp = DealWithHttp(getDiscountCodeRebateListHttp, HttpSuccessType2)
export const getDiscountCodeRebateListHttpHS = MobXHttp(DWgetDiscountCodeRebateListHttp)
/*#endregion*/

/*#region 修改下单折扣 */
const modifyDiscountHttp = BaseHttp<any, ApiResult3<TGetUserInfoForCommentResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/userCode/modifyDiscount`,
})
const DWmodifyDiscountHttp = DealWithHttp(modifyDiscountHttp, HttpSuccessType2)
export const modifyDiscountHttpHS = MobXHttp(DWmodifyDiscountHttp)
/*#endregion*/

/*#region 识别下单折扣 */
const discountCodeInfoHttp = BaseHttp<any, ApiResult3<TGetUserDiscountCode>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/userCode/discountCodeInfo`,
})
const DWdiscountCodeInfoHttp = DealWithHttp(discountCodeInfoHttp, HttpSuccessType2)
export const discountCodeInfoHttpHS = MobXHttp(DWdiscountCodeInfoHttp)
/*#endregion*/

/*#region 获取折扣系统是否被关闭 */
const discountCodeIsClosed = BaseHttp<any, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/userCode/isClose`,
})
const DWdiscountCodeIsClosed = DealWithHttp(discountCodeIsClosed, HttpSuccessType2)
export const discountCodeIsClosedHS = MobXHttp(DWdiscountCodeIsClosed)
/*#endregion*/

/*#region 订单是否可换购  */
const checkCanRefundOrSwap = BaseHttp<{ orderNo: string }, ApiResult3<{ refundCode: number; canSwap: boolean }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/canRefundOrSwap`,
})
export const DWCheckCanRefundOrSwap = DealWithHttp(checkCanRefundOrSwap, HttpSuccessType2)
export const checkCanRefundOrSwapHS = MobXHttp(DWCheckCanRefundOrSwap)
/*#endregion*/

/*#region 提现配置  */
const getWithdrawalConfig = BaseHttp<{ 'APPLICATION-GROUP': '99box' }, ApiResult3<TWithdrawalConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/withdrawal/config`,
})
export const DWgetWithdrawalConfig = DealWithHttp(getWithdrawalConfig, HttpSuccessType2)
export const getWithdrawalConfigHS = MobXHttp(DWgetWithdrawalConfig)
/*#endregion*/

/*#region 自动登录信息查询  */
const getAutoLoginInfo = BaseHttp<{ downloadId: string }, ApiResult3<IAutoLoginInfo>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/gog/auto/login/info`,
})
export const DWGetAutoLoginInfo = DealWithHttp(getAutoLoginInfo, HttpSuccessType2)
export const getAutoLoginInfoHS = MobXHttp(DWGetAutoLoginInfo)
/*#endregion*/

/*#region 自动登录  */
const autoLogin = BaseHttp<{ downloadId: string; autoLoginId: string; maskMobile: string }, ApiResult<UserLogin>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/gog/auto/login/login`,
})
export const DWGetAutoLogin = DealWithHttp(autoLogin, HttpSuccessType1)

/*#region 是否领取过新人福利  */
const isReceiveNewUser = BaseHttp<{ activityNo: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/isReceive/newUser/giftBag`,
})
export const DWisReceiveNewUser = DealWithHttp(isReceiveNewUser, HttpSuccessType2)
export const isReceiveNewUserHS = MobXHttp(DWisReceiveNewUser)
/*#endregion*/

/*#region 新人礼包时长配置查询  */
const giftBagConfig = BaseHttp<{}, ApiResult3<{ vipDur: number; cloudGameDur: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/newUser/giftBagConfig`,
})
export const DWgiftBagConfig = DealWithHttp(giftBagConfig, HttpSuccessType2)
export const giftBagConfigHS = MobXHttp(DWgiftBagConfig)
/*#endregion*/

/*#region 领取礼包接口  */
const receiveGiftBag = BaseHttp<{ trialCardId: string }, ApiResult3<TreceiveInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/receiveGiftBag`,
})
export const DWreceiveGiftBag = DealWithHttp(receiveGiftBag, HttpSuccessType2)
export const receiveGiftBagHS = MobXHttp(DWreceiveGiftBag)
/*#endregion*/

/*#region 用户换绑手机号第一步：验证身份  */
const changeMobileStep1 = BaseHttp<{ code: string }, ApiResult3<string>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/changeMobile/step1`,
})
export const changeMobileStep1HS = DealWithHttp(changeMobileStep1, HttpSuccessType2)
/*#endregion*/

/*#region 用户换绑手机号第二步：换绑手机号  */
const changeMobileStep2 = BaseHttp<{ code: string; ticket: string; mobile: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/changeMobile/step2`,
})
export const changeMobileStep2HS = DealWithHttp(changeMobileStep2, HttpSuccessType2)
/*#endregion*/

/*#region 换绑手机号  */
const changeBindMobile = BaseHttp<{ mobile: string; code: string; beforeCode: string }, ApiResult3<boolean>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/changeBindMobile`,
})
export const changeBindMobileHS = DealWithHttp(changeBindMobile, HttpSuccessType2)
/*#endregion*/

/*#region 获取充值记录  */
const rechargeDetailList = BaseHttp<{}, ApiResult3<TchargeList[]>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/account/rechargeDetailList`,
})
export const getRechargeDetailList = DealWithHttp(rechargeDetailList, HttpSuccessType2)
export const getRechargeDetailListHS = MobXHttp(getRechargeDetailList)
/*#endregion*/

/*#region 获取邀请码赠送会员天数  */
const getInviteGivingVipDur = BaseHttp<{}, ApiResult3<{ inviteUserGivingDur: number; beinvitedUserGivingDur: number }>>(
  {
    Type: 'Get',
    Url: `${API_URL.BOX_WEB}/api/getInviteGivingVipDur`,
  },
)
export const DWgetInviteGivingVipDur = DealWithHttp(getInviteGivingVipDur, HttpSuccessType2)
export const getInviteGivingVipDurHs = MobXHttp(DWgetInviteGivingVipDur)
/*#endregion*/

/*#region 获取我的邀请记录  */
const getInvitedList = BaseHttp<
  { token: string; pageSize: number; page: number; queryType?: string },
  ApiResult3<PageResult<any>>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/vip/invited/list`,
})
export const DWgetInvitedList = DealWithHttp(getInvitedList, HttpSuccessType2)
export const getInvitedListHs = MobXHttp(DWgetInvitedList)
/*#endregion*/

/*#region 获取我的领取的总时长  */
const getGivingVipDayCount = BaseHttp<{}, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/vip/invited/giving/vip/day/count`,
})
export const DWgetGivingVipDayCount = DealWithHttp(getGivingVipDayCount, HttpSuccessType2)
export const getGivingVipDayCountHs = MobXHttp(DWgetGivingVipDayCount)
/*#endregion*/

/*#region 获取我的邀请的总人数  */
const getVipInvitedUserCount = BaseHttp<{}, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/vip/invited/user/count`,
})
export const DWgetVipInvitedUserCount = DealWithHttp(getVipInvitedUserCount, HttpSuccessType2)
export const getVipInvitedUserCountHs = MobXHttp(DWgetVipInvitedUserCount)
/*#endregion*/
/*#region 获取我的优惠券列表  */
const getCouponList = BaseHttp<TCouponListQuery, ApiResult3<WithPages<TCouponList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/coupon/list`,
})
export const DWgetCouponList = DealWithHttp(getCouponList, HttpSuccessType2)
export const getCouponListHS = MobXHttp(DWgetCouponList)
/*#endregion*/

/*#region 获取下单页可用的优惠券列表  */
const couponOfCreateorder = BaseHttp<
  {
    gameId: number
    orderType: number
    channel?: string
    activityNo?: string
    activityType?: string
    payAmt?: number
    goodsIds?: string
  },
  ApiResult3<TCouponList[]>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/available/coupon/of/createorder`,
})
export const DWcouponOfCreateorder = DealWithHttp(couponOfCreateorder, HttpSuccessType2)
export const couponOfCreateorderHS = MobXHttp(DWcouponOfCreateorder)
/*#endregion*/

/*#region 获取下单页可用的优惠券列表  */
const getVipPlayNum = BaseHttp<any, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/vip/canPlay/num`,
})
export const DWgetVipPlayNum = DealWithHttp(getVipPlayNum, HttpSuccessType2)
/*#endregion*/

/*#region 取消订单  */
const orderCancel = BaseHttp<{ orderNo: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/order/cancel`,
})
export const DWorderCancel = DealWithHttp(orderCancel, HttpSuccessType2)
export const orderCancelHS = MobXHttp(DWorderCancel)
/*#endregion*/

/*#region 取消订单  */
const checkCoupon = BaseHttp<{ couponNo: string }, ApiResult3<boolean>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/checkCoupon`,
})
export const DWcheckCoupon = DealWithHttp(checkCoupon, HttpSuccessType2)
export const checkCouponHS = MobXHttp(DWcheckCoupon)
/*#endregion*/

/**
 * 获取发券活动发券列表
 * 结果为空时 表示用户已经领取过了
 * 结果不为空时，代表后端返回券的同时已经赠送给用户了
 */
const grantCoupon = BaseHttp<{}, ApiResult3<{ reviceCoupon: boolean; couponActivityInfoVoList: TgrantCoupon[] }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/get/couponList/grantCoupon`,
})
export const DWgrantCoupon = DealWithHttp(grantCoupon, HttpSuccessType2)
export const grantCouponHS = MobXHttp(DWgrantCoupon)

/**
 * 判断订单是否会发放优惠券 同时返回优惠券信息
 * 结果为空时 表示该订单不能返回优惠券
 * 结果不为空时，代表后端返回券的同时已经赠送给用户了
 */
const grantCouponList = BaseHttp<{ orderNo: string }, ApiResult3<TgrantCoupon[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/order/can/grantCouponList`,
})
export const DWgrantCouponList = DealWithHttp(grantCouponList, HttpSuccessType2)
export const grantCouponListHS = MobXHttp(DWgrantCouponList)
/*#region 当前可参与免单的订单列表  */
const cashbackOrderList = BaseHttp<{ pageSize: number; pageIndex: number }, ApiResult3<PageResult<ICashbackOrderItem>>>(
  {
    Type: 'Get',
    Url: `${API_URL.BOX_WEB}/pay/cashback/orderList`,
  },
)
export const DWCashbackOrderList = DealWithHttp(cashbackOrderList, HttpSuccessType2)
/*#endregion*/

/*#region 免单排行榜  */
const cashbackUserList = BaseHttp<{ pageSize: number; pageIndex: number }, ApiResult3<PageResult<IRankItem>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/pay/cashback/userList`,
})
export const DWCashbackUserList = DealWithHttp(cashbackUserList, HttpSuccessType2)
/*#endregion*/

/*#region 当前可参与免单的订单列表  */
const cashbackBeInviterList = BaseHttp<{ pageSize: number; pageIndex: number }, ApiResult3<PageResult<IInviteUser>>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/pay/cashback/beinviterList`,
})
export const DWCashbackBeInviterList = DealWithHttp(cashbackBeInviterList, HttpSuccessType2)
/*#endregion*/

/*#region 订单是否可以免单  */
const checkCanCashback = BaseHttp<{ orderNo: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/can/cashback`,
})
export const DWCheckCanCashback = DealWithHttp(checkCanCashback, HttpSuccessType2)
/*#endregion*/

/** 获取余额信息 */
const getBaseBalanceInfo = BaseHttp<{}, ApiResult3<GetBaseBalanceInfoResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/base/info/get`,
})
export const DWgetBaseBalanceInfo = DealWithHttp(getBaseBalanceInfo, HttpSuccessType2)
export const getBaseBalanceInfoHS = MobXHttp(DWgetBaseBalanceInfo)

/** 上报标记信息 */
const reportUserMark = BaseHttp<{ name: string; value: number; subjectId: number }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/subjectMark/anon/report`,
})
export const reportUserMarkHttp = DealWithHttp(reportUserMark, HttpSuccessType2)

/** 双旦活动自动化领取优惠券 */
const userCouponAutomaticBind = BaseHttp<{ activityNo: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/coupon/automatic/bind`,
})
export const userCouponAutomaticBindHttp = DealWithHttp(userCouponAutomaticBind, HttpSuccessType2)

/** 双旦活动查询优惠券面额 */
const activityCouponAmountInfo = BaseHttp<{ activityNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/coupon/amount/info`,
})
export const activityCouponAmountInfoHttp = DealWithHttp(activityCouponAmountInfo, HttpSuccessType2)

/** 查询是否存在标记信息 name:自定义模块名称 */
const queryUserMark = BaseHttp<{ name: string; subjectId: number }, ApiResult3<TqueryUserMark>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/subjectMark/anon/queryUserMark`,
})
export const DWqueryUserMark = DealWithHttp(queryUserMark, HttpSuccessType2)
export const queryUserMarkHS = MobXHttp(DWqueryUserMark)

/** 获取用户购买信息 */
const getActivityUserPurchaseInfo = BaseHttp<any, ApiResult3<TActivityUserPurchaseInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/purchase/info`,
})
export const DWgetActivityUserPurchaseInfo = DealWithHttp(getActivityUserPurchaseInfo, HttpSuccessType2)

/** 获取用户可用的会员优惠券 */
const userCouponAvailableVipOrder = BaseHttp<{ channel: string }, ApiResult3<{ denomination: number }[]>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/coupon/available/vip/order`,
})
export const userCouponAvailableVipOrderHttp = DealWithHttp(userCouponAvailableVipOrder, HttpSuccessType2)

/* 获取每日礼包活动配置 */
const queryUnpackingPrizeConfig = BaseHttp<{ id: number }, ApiResult3<UnpackingPrizeConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activity/queryUnpackingPrizeConfig`,
})
export const DWqueryUnpackingPrizeConfig = DealWithHttp(queryUnpackingPrizeConfig, HttpSuccessType2)
export const queryUnpackingPrizeConfigHS = MobXHttp(DWqueryUnpackingPrizeConfig)

/** 每日礼包领取记录 */
const queryUnpackingPrizeRecord = BaseHttp<{ type: string }, ApiResult3<PrizeRecord>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/queryUnpackingPrizeRecord`,
})
export const DWQueryUnpackingPrizeRecord = DealWithHttp(queryUnpackingPrizeRecord, HttpSuccessType2)
export const queryUnpackingPrizeRecordHS = MobXHttp(DWQueryUnpackingPrizeRecord)

/** 领取每日礼包 */
const unpackingPrize = BaseHttp<{ type: string; prize: string }, ApiResult3<GetBaseBalanceInfoResult>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/activity/unpackingPrize`,
})
export const DWUnpackingPrize = DealWithHttp(unpackingPrize, HttpSuccessType2)

/** 预约活动 */
const activitySubscribe = BaseHttp<{ type: string }, ApiResult3<GetBaseBalanceInfoResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/subscribe`,
})
export const DWActivitySubscribe = DealWithHttp(activitySubscribe, HttpSuccessType2)

/** 查询用户是否预约  */
const queryUserHasSubscribe = BaseHttp<{ type: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/queryUserHasSubscribe`,
})
export const DWQueryUserHasSubscribe = DealWithHttp(queryUserHasSubscribe, HttpSuccessType2)
export const queryUserHasSubscribeHS = MobXHttp(DWQueryUserHasSubscribe)

/** 查询预约用户数量  */
const activityCountUser = BaseHttp<{ type: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/activity/countUser`,
})
export const DWActivityCountUser = DealWithHttp(activityCountUser, HttpSuccessType2)
export const activityCountUserHS = MobXHttp(DWActivityCountUser)

/** --上报用户已经被提醒预约信息 */
const updateNoticeFlag = BaseHttp<{ type: string }, ApiResult3<null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/subscribe/updateNoticeFlag`,
})
export const DWupdateNoticeFlag = DealWithHttp(updateNoticeFlag, HttpSuccessType2)
export const updateNoticeFlagHS = MobXHttp(DWupdateNoticeFlag)

/** --查询用户预约信息 */
const queryUserSubscribeInfo = BaseHttp<{ type: string }, ApiResult3<{ noticeFlag: 0 | 1 }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/activity/queryUserSubscribeInfo`,
})
export const DWqueryUserSubscribeInfo = DealWithHttp(queryUserSubscribeInfo, HttpSuccessType2)
export const queryUserSubscribeInfoHS = MobXHttp(DWqueryUserSubscribeInfo)

// /** 校验用户是否已参与某活动  */
const activityParticipated = BaseHttp<{ activityNo: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/activity/participated`,
})
export const DWActivityParticipated = DealWithHttp(activityParticipated, HttpSuccessType2)

/** 设置密码 */
const setPassword = BaseHttp<{ password: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/info/setPassword`,
})
export const DWSetPassword = DealWithHttp(setPassword, HttpSuccessType2)

/** 重置密码 */
const resetPassword = BaseHttp<IResetPasswordParam, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/api/resetPassword`,
})
export const DWResetPassword = DealWithHttp(resetPassword, HttpSuccessType2)

/** 修改密码 */
const updatePassword = BaseHttp<{ oldPassword: string; password: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/info/updatePassword`,
})
export const DWUpdatePassword = DealWithHttp(updatePassword, HttpSuccessType2)

/** 校验验证码 */
const verificationCode = BaseHttp<{ mobile: string; code: string; codeType: 'UP_PASS' }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/verificationCode/check`,
})
export const DWVerificationCode = DealWithHttp(verificationCode, HttpSuccessType2)

/** 获取微信退款时间文案配置 */
const getWechatRefundConfig = BaseHttp<{}, ApiResult3<{ timeout: string; newUserTimeout: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/global_config/speed_refund`,
})
export const DWgetWechatRefundConfig = DealWithHttp(getWechatRefundConfig, HttpSuccessType2)

/** 查询购买成功订单信息 */
const orderPurchased = BaseHttp<{ orderNo: string }, ApiResult3<OrderPurchased>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/purchased`,
})
export const DWOrderPurchased = DealWithHttp(orderPurchased, HttpSuccessType2)

/** 查询购买成功订单信息 */
const hasWechatPayInLast24Hours = BaseHttp<null, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/info/hasWechatPayInLast24Hours`,
})
export const DWHasWechatPayInLast24Hours = DealWithHttp(hasWechatPayInLast24Hours, HttpSuccessType2)

/** 查询最近微信支付时间戳 */
const hasWechatPayInLastTime = BaseHttp<null, ApiResult3<number | null>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/order/info/latest/payment/time`,
})
export const DWhasWechatPayInLastTime = DealWithHttp(hasWechatPayInLastTime, HttpSuccessType2)

/** 查询当前用户是否拥有支持云游戏的游戏 */
const hasUserGameSupportCloudGamesHttp = BaseHttp<null, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/userGame/query/hasUserGameSupportCloudGames`,
})
export const DWHasUserGameSupportCloudGamesHttp = DealWithHttp(hasUserGameSupportCloudGamesHttp, HttpSuccessType2)

/** 查询当前用户会员信息 */
const queryVipInfoHttp = BaseHttp<
  null,
  ApiResult3<null | { createTime: string; vipType: 'expe' | 'year' | 'forever' }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/query/vip/info`,
})
export const DWQueryVipInfoHttp = DealWithHttp(queryVipInfoHttp, HttpSuccessType2)

/** 查询要加入的开黑的社群列表 */
const getNeedJoinKaiheiCommunityIdsByUser = BaseHttp<null, ApiResult3<string[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/user/game/kaihei/groups`,
})
export const DWgetNeedJoinKaiheiCommunityIdsByUser = DealWithHttp(getNeedJoinKaiheiCommunityIdsByUser, HttpSuccessType2)

/** 查询用户升级vip活动信息 */
const getUpgradeVipInfo = BaseHttp<{ activityNo: string; channel: string }, ApiResult3<IUpgradeVipInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/forever/vip/config`,
})
export const DWgetUpgradeVipInfo = DealWithHttp(getUpgradeVipInfo, HttpSuccessType2)
export const getUpgradeVipInfoHS = MobXHttp(DWgetUpgradeVipInfo)

/** 获取用户可用抽奖次数 */
const getAvailableDrawCount = BaseHttp<{ activityNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/availableDrawCount`,
})
export const DWgetAvailableDrawCount = DealWithHttp(getAvailableDrawCount, HttpSuccessType2)
export const getAvailableDrawCountHs = MobXHttp(DWgetAvailableDrawCount)

/** 抽奖 */
const activityReceive = BaseHttp<
  { activityNo: string; userId: number },
  ApiResult3<{ identity: string; describe: string }>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/activity/receive`,
})
export const DWactivityReceive = DealWithHttp(activityReceive, HttpSuccessType2)
export const activityReceiveHs = MobXHttp(DWactivityReceive)

/** 校验用户活动下单资格 */
const eligibilityCheck = BaseHttp<{ activityNo: string; goodsId: number }, ApiResult3<boolean>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/activity/order/eligibility/check`,
})
export const DWEligibilityCheck = DealWithHttp(eligibilityCheck, HttpSuccessType2)

/** 免费CDK领取接口 */
const activityUserReceive = BaseHttp<{ activityNo: string; goodsId: number }, ApiResult3<{ ownExclusive: boolean }>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/activity/user/receive`,
})
export const DWActivityUserReceive = DealWithHttp(activityUserReceive, HttpSuccessType2)

/** 校验用户是否有pubg独享（免费cd活动用）  */
const userOwnExclusive = BaseHttp<null, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/ownExclusive`,
})
export const DWUserOwnExclusive = DealWithHttp(userOwnExclusive, HttpSuccessType2)

/** 领取活动优惠券 */
const activityReceiveCoupon = BaseHttp<{ activityNo: string; identity: number }, ApiResult3<{ bizNo: string }[]>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/activity/user/receive`,
})
export const activityReceiveCouponHttp = DealWithHttp(activityReceiveCoupon, HttpSuccessType2)

/** 批量获取优惠券详情 */
const getCouponListByCouponNos = BaseHttp<{ couponNos: string }, ApiResult3<TCouponList[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/coupon/list/by/coupon/nos`,
})
export const getCouponListByCouponNosHttp = DealWithHttp(getCouponListByCouponNos, HttpSuccessType2)

/** 获取用户的平台账号列表）  */
const userPlatformAccount = BaseHttp<
  { platform: string; userGameAccountType: number; platformServer: string; gameLibraryId: number },
  ApiResult3<AccountListByGameLibraryId[]>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/usergame/asset/account/platform`,
})
export const DWUserPlatformAccount = DealWithHttp(userPlatformAccount, HttpSuccessType2)

/** 校验账号是否登录过，是否有cookie*/
const checkAccountCookie = BaseHttp<{ orderNo?: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/order/stock/info/query/isLogin`,
})
export const DWCheckAccountCookie = DealWithHttp(checkAccountCookie, HttpSuccessType2)

/** 领取抽奖次数 */
const receiveLuckNum = BaseHttp<{ activityNo: string; receiveType: 'lottery_number' }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/activity/user/receive`,
})
export const receiveLuckNumHttp = DealWithHttp(receiveLuckNum, HttpSuccessType2)

/** 返回用户游戏的统计数据 */
const queryUserGameStatistics = BaseHttp<{}, ApiResult3<TQueryUserGameStatistics[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/userGame/statistics/query`,
})
export const queryUserGameStatisticsHttp = DealWithHttp(queryUserGameStatistics, HttpSuccessType2)

/** 领取优惠券 */
const receiveUserCoupon = BaseHttp<{ activityNo: string; couponTemplateNo: string }, ApiResult3<{}>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/user/coupon/receive`,
})
export const receiveUserCouponHttp = DealWithHttp(receiveUserCoupon, HttpSuccessType2)

/** 邀请排行榜 */
const discountCodeTop = BaseHttp<{ limit?: number }, ApiResult3<TDiscountCodeTop[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/discount/code/top`,
})
export const discountCodeTopHttp = DealWithHttp(discountCodeTop, HttpSuccessType2)

/** 首购活动资格 */
const activityUserQualification = BaseHttp<{ activityNo: string }, ApiResult3<IFirstPurchaseGiftConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/user/qualification`,
})
export const activityUserQualificationHttp = DealWithHttp(activityUserQualification, HttpSuccessType2)
export const activityUserQualificationHs = MobXHttp(activityUserQualificationHttp)

/** 首购活动赠品列表 */
const activityGifts = BaseHttp<
  { activityNo: string },
  ApiResult3<
    {
      goodsId: number
      icon: string
      productName: string
      sourcePrice: number
      accountType: TGiftType
      threeGoodsFactory: string
    }[]
  >
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/gifts`,
})
export const activityGiftsHttp = DealWithHttp(activityGifts, HttpSuccessType2)
export const activityGiftsHttpHs = MobXHttp(activityGiftsHttp)

/** 首购活动商品列表 */
const firstAactivityGoodsList = BaseHttp<{ activityNo: string }, ApiResult3<IActivityGoods[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/activity/goods/list`,
})
export const DWfirstActivityGoodsList = DealWithHttp(firstAactivityGoodsList, HttpSuccessType2)
export const firstActivityGoodsListHS = MobXHttp(DWfirstActivityGoodsList)
/** 获取订单计数 */
const getPayOrderInfo = BaseHttp<{ orderNo: string }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/my/order/count`,
})
export const DWGetPayOrderInfo = DealWithHttp(getPayOrderInfo, HttpSuccessType2)

/** 获取启动推荐页游戏 */
const getUserGamePageRecommend = BaseHttp<{}, ApiResult3<TGetUserGamePageRecommend>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/game/page/recommend`,
})
export const getUserGamePageRecommendHttp = DealWithHttp(getUserGamePageRecommend, HttpSuccessType2)
/** 购买成功页 是否展示汉化包温馨提示 */
const getPurchasedRecommendListFlag = BaseHttp<
  { goodsId: number },
  ApiResult3<{ recommend: boolean; goodsId: number }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/game/chinesization/pack/purchasedRecommend`,
})
export const getPurchasedRecommendListFlagHttp = DealWithHttp(getPurchasedRecommendListFlag, HttpSuccessType2)

/** 联合会员提交手机号 */
const submitUniteVipInfo = BaseHttp<{ orderNo: string; rechargeMobile: string; mainNo: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/submit/recgarge/information
`,
})
export const submitUniteVipInfoHttp = DealWithHttp(submitUniteVipInfo, HttpSuccessType2)

// 已废弃

/*#region 邀请成功*/
// const InvitedSuccessListHttp = BaseHttp<any, ApiResult2<{ mobile: string; amount: number }[]>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/invited/user/money`,
// })
// const DWInvitedSuccessListHttp = DealWithHttp(InvitedSuccessListHttp, HttpSuccessType2)
// export const InvitedSuccessListHS = MobXHttp(DWInvitedSuccessListHttp)
/*#endregion*/

/*#region 邀请成功*/
// const GenerationCodeHttp = BaseHttp<any, ApiResult2<string>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/invited/code/generation`,
// })
// const DWGenerationCodeHttp = DealWithHttp(GenerationCodeHttp, HttpSuccessType2)
// export const GenerationCodeHS = MobXHttp(DWGenerationCodeHttp)
/*#endregion*/

/*#region 邀请数量*/
// const InvitedCountHttp = BaseHttp<any, ApiResult2<{ peopleNum: number; totalMoney: number }>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/my/invited/count`,
// })
// const DWInvitedCountHttp = DealWithHttp(InvitedCountHttp, HttpSuccessType2)
// export const InvitedCountHS = MobXHttp(DWInvitedCountHttp)
/*#endregion*/

/*#region 邀请列表*/
// const InvitedListHttp = BaseHttp<
//   { pageSize: number; page: number },
//   ApiResult2<{ data: InvitedItem[]; totalPages: number }>
// >({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/my/invited/list`,
// })
// const DWInvitedListHttp = DealWithHttp(InvitedListHttp, HttpSuccessType2)
// export const InvitedListHS = MobXHttp(DWInvitedListHttp)
/*#endregion*/

/*#region 查询vip配置 java*/
// const VipCfgHttp = BaseHttp<{ channel: string }, ApiResult2<VipPriceCfg>>({
//   Type: 'Get',
//   Url: `${API_URL.BOX_WEB}/anon/box/vip/price/get`,
// })

// export const DWVipCfgHttp = DealWithHttp<{ channel: string }, ApiResult2<VipPriceCfg>, VipPriceCfg>(
//   VipCfgHttp,
//   HttpSuccessType2,
// )
/*#endregion*/
